import React from 'react'

const Modal = ({
  showModal,
  handleCloseModal,
  title,
  children,
  modalWidth = { width: '600px' },
}) => {
  if (!showModal) {
    return null
  }

  return (
    <>
      <div
        className="modal-backdrop"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1040,
        }}
      ></div>

      <div
        className="modal"
        style={{
          display: 'block',
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1050,
        }}
      >
        <div
          className="modal-dialog"
          style={{ ...modalWidth, maxWidth: '95%' }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            <div
              className="modal-header"
              style={{ backgroundColor: '#262E3D', padding: '12px' }}
            >
              <h6 className="modal-title text-white">{title}</h6>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseModal}
                style={{ backgroundColor: 'white', marginRight: '1px' }}
              ></button>
            </div>
            <div className="modal-body">{children}</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Modal
